import React from 'react'
import MainComponent from 'src/Libs/shop/components/SystemConfiguration/MainComponent'
import { useNormalSystemConfigurationContext } from 'src/Libs/shop/context/use-shop-normal-system-configuration-context'
import { useShopNormalMainComponent } from '../hooks/use-shop-normal-main-component'

/*
 * Wrapper for Main Component step connecting hook data with configurator context
 */
const NormalMainComponent: React.FC = () => {
  const { setAllowContinueMain } = useNormalSystemConfigurationContext()
  const { title, categories, isLoading, showRetrofitBattery, onBack, onMoreInfo, onSelectProduct, isProductSelected, canContinue } =
    useShopNormalMainComponent()

  return (
    <MainComponent
      title={title}
      categories={categories}
      isLoading={isLoading}
      showRetrofitBattery={showRetrofitBattery}
      onBack={onBack}
      onMoreInfo={onMoreInfo}
      onSelectProduct={onSelectProduct}
      isProductSelected={isProductSelected}
      canContinue={canContinue}
      onAllowContinueChange={setAllowContinueMain}
    />
  )
}

export default NormalMainComponent
